//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.RefreshTokenMutation
import kotlin.String
import kotlin.collections.List

public object RefreshTokenMutation_ResponseAdapter {
  public object Data : Adapter<RefreshTokenMutation.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("refreshToken")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): RefreshTokenMutation.Data {
      var _refreshToken: RefreshTokenMutation.RefreshToken? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _refreshToken = RefreshToken.obj().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return RefreshTokenMutation.Data(
        refreshToken = _refreshToken ?: missingField(reader, "refreshToken")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: RefreshTokenMutation.Data,
    ) {
      writer.name("refreshToken")
      RefreshToken.obj().toJson(writer, customScalarAdapters, value.refreshToken)
    }
  }

  public object RefreshToken : Adapter<RefreshTokenMutation.RefreshToken> {
    public val RESPONSE_NAMES: List<String> = listOf("loginToken", "refreshToken")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): RefreshTokenMutation.RefreshToken {
      var _loginToken: String? = null
      var _refreshToken: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _loginToken = StringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _refreshToken = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return RefreshTokenMutation.RefreshToken(
        loginToken = _loginToken ?: missingField(reader, "loginToken"),
        refreshToken = _refreshToken ?: missingField(reader, "refreshToken")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: RefreshTokenMutation.RefreshToken,
    ) {
      writer.name("loginToken")
      StringAdapter.toJson(writer, customScalarAdapters, value.loginToken)

      writer.name("refreshToken")
      StringAdapter.toJson(writer, customScalarAdapters, value.refreshToken)
    }
  }
}
